import { render, staticRenderFns } from "./EditShippingSubModal.vue?vue&type=template&id=4d9da146&scoped=true"
import script from "./EditShippingSubModal.vue?vue&type=script&lang=js"
export * from "./EditShippingSubModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9da146",
  null
  
)

export default component.exports